import Impfschema from '@/types/Impfschema';

export default class Elgaimpfstoffe {
    public impfstoff_code: string | null = null;
    public displayname: string | null = null;
    public bezeichnung_arzneispezialitaet_zulassung: string | null = null;
    public groessegewicht: number | null = null;
    public mengenart: string | null = null;
    public elga_gueltigkeit: string | null = null;
    public elga_impfungindikation_k_code: number | null = null;
    public elga_impfungindikation_01_code: string | null = null;
    public elga_impfungindikation_02_code: string | null = null;
    public elga_impfungindikation_03_code: string | null = null;
    public elga_impfungindikation_04_code: number | null = null;
    public elga_impfungindikation_05_code: number | null = null;
    public elga_impfungindikation_06_code: number | null = null;
    public ordernumber: number | null = null;
    public target_displayname: string | null = null;
    public target_gruppe: string | null = null;
    public target01_displayname: string | null = null;
    public target01_gruppe: string | null = null;
    public impfschemen: Impfschema[] | null = null;

    constructor(data?: Partial<Elgaimpfstoffe>) {
        Object.assign(this, data);
    }
}
